import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import Header from '../components/Header';
import { SEO } from '../components/SEO';
import Hero from '../components/Hero';
import About from '../components/About';
import Reading from '../pages/Reading';
import Events from '../pages/Events';
import EventDetail from '../pages/EventDetail';
import Partnerships from '../pages/Partnerships';
import Facilitator from '../pages/Facilitator';
import Member from '../pages/Member';
import PrayerFasting from '../pages/PrayerFasting';
import RegularEvents from '../components/Events';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import toast from 'react-hot-toast';

const MainLayout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('error=access_denied') && hash.includes('otp_expired')) {
      toast.error('The password reset link has expired. Please request a new one.');
      navigate('/admin', { replace: true });
      return;
    }
    if (hash.includes('type=recovery') || hash.includes('access_token')) {
      navigate('/admin' + hash, { replace: true });
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        navigate('/admin', { replace: true, state: { passwordRecovery: true } });
      }
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const sections = document.querySelectorAll('section');
      
      sections.forEach(section => {
        const sectionTop = section.offsetTop - 100;
        const sectionBottom = sectionTop + section.offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          const id = section.getAttribute('id');
          
          document.querySelectorAll('nav a').forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${id}`) {
              link.classList.add('active');
            }
          });
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={
            <>
              <SEO 
                title="Monday Night Group | Men's Community in Nashville"
                description="Join our community of men meeting every Monday in Nashville to connect, learn, and grow together through Bible study, fellowship, and authentic relationships."
                image="https://images.squarespace-cdn.com/content/v1/5eb1c6378916cd57dea5228e/5498e725-e5a2-451d-b56e-bebe606d8cc1/Untitled+design+%282%29.png"
                url="https://mondaynightgroup.com"
              />
              <Hero />
              <About />
              <RegularEvents />
              <Contact />
            </>
          } />
          <Route path="/reading" element={<Reading />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/facilitator" element={<Facilitator />} />
          <Route path="/member" element={<Member />} />
          <Route path="/prayer-fasting" element={<PrayerFasting />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;